module.exports = __webpack_public_path__ + "static/service-boundary-5-1d11b5ba7956772b8346057d42f56255.png";